// @flow
import React, { useEffect, useState, useRef } from 'react';
import { Badge, Button, Card, Col, Form, Row } from 'react-bootstrap';
import HyperDatepicker from '../../components/Datepicker';
import { FormInput } from '../../components';
import { useSelector } from 'react-redux';
import { Loading } from 'react-loading-ui';
import {
    getAllStationAPI,
    getDeviceAPI,
    getReportAPI,
    getReportGraphAPI,
    getUserStationAPI,
} from '../../API/RDPMS_API';
import { ToastContainer, toast } from 'react-toastify';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Table from '../../components/Table';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import reportImg from '../../assets/images/report.png';
import CurrentLineChart from '../charts/Echarts/DcCIrcuit/CurrentLineChart';
import VoltageLineChart from '../charts/Echarts/DcCIrcuit/VoltageLineChart';
import ChargerCurrentLineChart from '../charts/Echarts/DcCIrcuit/ChargerCurrentLineChart';
import TPRStatusStepLineChart from '../charts/Echarts/DcCIrcuit/TPRStatusStepLineChart';
import ChargerPotentialFreeContactStepLineChart from '../charts/Echarts/DcCIrcuit/ChargerPotentialFreeContactStepLineChart';
import PointPositionStepLineChart from '../charts/Echarts/PointMachine/PointPositionStepLineChart';
import OperatingVoltageLineChart from '../charts/Echarts/PointMachine/OperatingVoltageLineChart';
import OperatingCurrentLineChart from '../charts/Echarts/PointMachine/OperatingCurrentLineChart';
import ACCurrentLineChart from '../charts/Echarts/Signal/ACCurrentLineChart';
import ACVoltageLineChart from '../charts/Echarts/Signal/ACVoltageLineChart';
import ChargerInputVoltagetLineChart from '../charts/Echarts/Batteries/ChargerInputVoltagetLineChart';
import ChargerInputCurrenttLineChart from '../charts/Echarts/Batteries/ChargerInputCurrenttLineChart';
import ChargerOutputVoltagetLineChart from '../charts/Echarts/Batteries/ChargerOutputVoltagetLineChart';
import BatteryOutputCurrentLineChart from '../charts/Echarts/Batteries/BatteryOutputCurrentLineChart';
import BatteryOutputVoltageLineChart from '../charts/Echarts/Batteries/BatteryOutputVoltageLineChart';
import ChargerOutputCurrentLineChart from '../charts/Echarts/Batteries/ChargerOutputCurrentLineChart';
import AvailabilityOfStandbyPowerSupplyStepLineChart from '../charts/Echarts/IPS/AvailabilityOfStandbyPowerSupplyStepLineChart';
import HealthOfIPSModelsThroughPFCStepLineChart from '../charts/Echarts/IPS/HealthOfIPSModelsThroughPFCStepLineChart';
import FRBCOutputVoltageLineChart from '../charts/Echarts/IPS/FRBCOutputVoltageLineChart';
import InverterOutputVoltageLineChart from '../charts/Echarts/IPS/InverterOutputVoltageLineChart';
import InverterOutputCurrentLineChart from '../charts/Echarts/IPS/InverterOutputCurrentLineChart';
import InverterInputVoltageLineChart from '../charts/Echarts/IPS/InverterInputVoltageLineChart';
import DCConverterOutputCurrentLineChart from '../charts/Echarts/IPS/DCConverterOutputCurrentLineChart';
import DCConverterOutputVoltageLineChart from '../charts/Echarts/IPS/DCConverterOutputVoltageLineChart';
import BatteryChargingCurrentLineChart from '../charts/Echarts/IPS/BatteryChargingCurrentLineChart';
import InputCurrentLineChart from '../charts/Echarts/IPS/InputCurrentLineChart';
import InputVoltageLineChart from '../charts/Echarts/IPS/InputVoltageLineChart';
import RelayStepLineChart from '../charts/Echarts/PointMachine/RelayStepLineChart';

import InputCurrentHASSDACLineChart from '../charts/Echarts/HASSDAC/InputCurrentLineChart';
import InputVoltageHASSDACLineChart from '../charts/Echarts/HASSDAC/InputVoltageLineChart';
import VitalRelayVoltageLineChart from '../charts/Echarts/HASSDAC/VitalRelayVoltageLineChart';
import VitalRelayCurrentLineChart from '../charts/Echarts/HASSDAC/VitalRelayCurrentLineChart';
import ResetVoltageLineChart from '../charts/Echarts/HASSDAC/ResetVoltageLineChart';

import {
    batteriesColumns,
    dcCircuitColumns,
    hassdacColumns,
    IPSColumns,
    pointMachineColumns,
    SignalColumns,
} from '../../utils/ColumnUtils';
import { renderBadge, renderBadgeIPS, renderStatus } from '../../utils/statusUtils';

const ReportsAlertGraph = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedStation, setSelectedStation] = useState();
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedDevice, setSelectedDevice] = useState();
    const [deviceData, setDeviceData] = useState([]);
    const [station, setStation] = useState([]);

    const [dcCircuitData, setDcCircuitData] = useState([]);
    const [pointMachineData, setPointMachineData] = useState([]);
    const [signalData, setSignalData] = useState([]);
    const [batteriesData, setBatteriesData] = useState([]);
    const [ipsData, setIPSData] = useState([]);
    const [hasscadData, setHasscadData] = useState([]);

    const [dcCircuitGraph, setDcCircuitGraph] = useState({});
    const [pointMachineGraph, setPointMachineGraph] = useState({});
    const [signalGraph, setSignalGraph] = useState({});
    const [batteriesGraph, setBatteriesGraph] = useState({});
    const [ipsGraph, setIPSGraph] = useState({});
    const [hasscadGraph, setHasscadGraph] = useState({});

    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    useEffect(() => {
        const fetchStation = async () => {
            await getStation(auth.user._id);
        };

        fetchStation();
    }, []);

    const getStation = async (id) => {
        try {
            if (id) {
                Loading(true); // Show loading spinner
                const response = await getUserStationAPI(id);
                if (response && response.length > 0) {
                    setStation(response);
                }
            }
        } catch (error) {
            console.error('Error fetching station data:', error);
        } finally {
            Loading(false); // Hide loading spinner
        }
    };

    const handleDevice = async (e) => {
        try {
            // Show loading state
            Loading();

            // Update selected category and reset selected device
            const category = e.target.value;
            setSelectedCategory(category);
            setSelectedDevice(null);

            // Clear previous data and graphs
            setDcCircuitData([]);
            setPointMachineData([]);
            setSignalData([]);
            setBatteriesData([]);
            setIPSData([]);
            setHasscadData([]);

            setDcCircuitGraph({});
            setPointMachineGraph({});
            setSignalGraph({});
            setBatteriesGraph({});
            setIPSGraph({});
            setHasscadGraph({});

            // Validate category and station
            if (category && selectedStation) {
                const request = {
                    category: category,
                    stationId: selectedStation,
                };

                // Fetch device data
                const response = await getDeviceAPI(request);

                // If response contains data, update device state
                if (response && response.length > 0) {
                    setDeviceData(response);
                }
            }
        } catch (error) {
            console.error('Error fetching device data:', error);
            toast.error('Failed to fetch device data', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            // Hide loading state
            Loading();
        }
    };

    /*
     * handle date change
     */
    const handleGetReport = async () => {
        try {
            // Start loading indicator
            Loading();

            // Clear existing data and graphs
            setDcCircuitData([]);
            setPointMachineData([]);
            setSignalData([]);
            setBatteriesData([]);
            setIPSData([]);
            setHasscadData([]);

            setDcCircuitGraph({});
            setPointMachineGraph({});
            setSignalGraph({});
            setBatteriesGraph({});
            setIPSGraph({});
            setHasscadGraph({});

            // Ensure all required fields are selected
            if (selectedStation && selectedCategory && selectedDevice && selectedStartDate && selectedEndDate) {
                const request = {
                    stationId: selectedStation,
                    category: selectedCategory,
                    masterId: selectedDevice,
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                };

                const response = await getReportGraphAPI(request);
                console.log(response, 'response......');

                if (response) {
                    // Process each type of response data
                    if (response.dcCircuit && Object.keys(response.dcCircuit).length > 0) {
                        const dcCircuitDataArray = response.dcCircuit.tableData.map((t) => ({
                            id: t._id,
                            trackNumber: t.track_number,
                            feedEndVoltage: renderStatus(t.severity_status[0].feedEndVoltage, t.feed_end_voltage),
                            relayEndVoltage: renderStatus(t.severity_status[0].relayEndVoltage, t.relay_end_voltage),
                            chargerCurrent: renderStatus(t.severity_status[0].chargerCurrent, t.charger_current),
                            tprStatus: renderBadge(t.tpr_status),
                            chargerPotentialFreeContact: renderBadge(t.charger_potential_free_contact),
                            relayEndCurrent: renderStatus(t.severity_status[0].relayEndCurrent, t.relay_end_current),
                            feedEndCurrent: renderStatus(t.severity_status[0].feedEndCurrent, t.feed_end_current),
                            timeStamp: moment(t.created_at).format('DD MMM YYYY h:mm a'),
                        }));
                        setDcCircuitData(dcCircuitDataArray);
                        setDcCircuitGraph(response.dcCircuit);
                    }

                    if (response.pointMachine && Object.keys(response.pointMachine).length > 0) {
                        const pointMachineDataArray = response.pointMachine.tableData.map((t) => ({
                            id: t._id,
                            pointMachine: t.point_machine,
                            forwardOperatingCurrent: renderStatus(
                                t.severity_status[0].forwardOperatingCurrent,
                                t.forward_operating_current
                            ),
                            reverseOperatingCurrent: renderStatus(
                                t.severity_status[0].reverseOperatingCurrent,
                                t.reverse_operating_current
                            ),
                            forwardOperatingVoltage: renderStatus(
                                t.severity_status[0].forwardOperatingVoltage,
                                t.forward_operating_voltage
                            ),
                            reverseOperatingVoltage: renderStatus(
                                t.severity_status[0].reverseOperatingVoltage,
                                t.reverse_operating_voltage
                            ),
                            pointPositionVoltage: renderBadge(t.point_position_voltage),
                            vibration: renderStatus('NA', t.severity_status[0].vibration),
                            pointPositionRelay: renderBadge(t.point_position_relay),
                            timeStamp: moment(t.created_at).format('DD MMM YYYY h:mm a'),
                        }));
                        setPointMachineData(pointMachineDataArray);
                        setPointMachineGraph(response.pointMachine);
                    }

                    if (response.signal && Object.keys(response.signal).length > 0) {
                        const signalDataArray = response.signal.tableData.map((t) => ({
                            id: t._id,
                            signalNumber: t.signal_number,
                            redAcVoltage: renderStatus(t.severity_status[0].redAcVoltage, t.red_ac_voltage),
                            redAcCurrent: renderStatus(t.severity_status[0].redAcCurrent, t.red_ac_current),
                            greenAcVoltage: renderStatus(t.severity_status[0].greenAcVoltage, t.green_ac_voltage),
                            greenAcCurrent: renderStatus(t.severity_status[0].greenAcCurrent, t.green_ac_current),
                            yellowAcVoltage: renderStatus(t.severity_status[0].yellowAcVoltage, t.yellow_ac_voltage),
                            yellowAcCurrent: renderStatus(t.severity_status[0].yellowAcCurrent, t.yellow_ac_current),
                            otherAcVoltage: renderStatus(t.severity_status[0].otherAcVoltage, t.other_ac_voltage),
                            otherAcCurrent: renderStatus(t.severity_status[0].otherAcCurrent, t.other_ac_current),
                            status: renderBadge(t.health_status),
                            timeStamp: moment(t.created_at).format('DD MMM YYYY h:mm a'),
                        }));
                        setSignalData(signalDataArray);
                        setSignalGraph(response.signal);
                    }

                    if (response.batteries && Object.keys(response.batteries).length > 0) {
                        const batteriesDataArray = response.batteries.tableData.map((t) => ({
                            id: t._id,
                            batteryCharger: t.battery_charger,
                            chargerInputVoltage: renderStatus(
                                t.severity_status[0].chargerInputVoltage,
                                t.charger_input_voltage
                            ),
                            chargerInputCurrent: renderStatus(
                                t.severity_status[0].chargerInputCurrent,
                                t.charger_input_current
                            ),
                            chargerOutputVoltage: renderStatus(
                                t.severity_status[0].chargerOutputVoltage,
                                t.charger_output_voltage
                            ),
                            chargerOutputCurrent: renderStatus(
                                t.severity_status[0].chargerOutputCurrent,
                                t.charger_output_current
                            ),
                            batteryOutputVoltage: renderStatus(
                                t.severity_status[0].batteryOutputVoltage,
                                t.battery_output_voltage
                            ),
                            batteryOutputCurrent: renderStatus(
                                t.severity_status[0].batteryOutputCurrent,
                                t.battery_output_current
                            ),
                            timeStamp: moment(t.created_at).format('DD MMM YYYY h:mm a'),
                        }));
                        setBatteriesData(batteriesDataArray);
                        setBatteriesGraph(response.batteries);
                    }

                    if (response.ips && Object.keys(response.ips).length > 0) {
                        const ipsDataArray = response.ips.tableData.map((t) => ({
                            id: t._id,
                            ips: t.ips,
                            inputVoltage: renderStatus(t.severity_status[0].inputVoltage, t.input_voltage),
                            inputCurrent: renderStatus(t.severity_status[0].inputCurrent, t.input_current),
                            frbcOutputVoltage: renderStatus(
                                t.severity_status[0].FRBCOutputVoltage,
                                t.frbc_output_voltage
                            ),
                            batteryOutputVoltage: renderStatus(
                                t.severity_status[0].batteryOutputVoltage,
                                t.battery_output_voltage
                            ),
                            batteryChargingCurrent: renderStatus(
                                t.severity_status[0].batteryChargingCurrent,
                                t.battery_charging_current
                            ),
                            dcConverterOutputCurrent: renderStatus(
                                t.severity_status[0].dcConverterOutputCurrent,
                                t.dc_converter_output_current
                            ),
                            dcConverterOutputVoltage: renderStatus(
                                t.severity_status[0].dcConverterOutputVoltage,
                                t.dc_converter_output_voltage
                            ),
                            inverterInputVoltage: renderStatus(
                                t.severity_status[0].inverterInputVoltage,
                                t.inverter_input_voltage
                            ),
                            inverterOutputVoltage: renderStatus(
                                t.severity_status[0].inverterOutputVoltage,
                                t.inverter_output_voltage
                            ),
                            inverterOutputCurrent: renderStatus(
                                t.severity_status[0].inverterOutputCurrent,
                                t.inverter_output_current
                            ),
                            healthOfIPSModulesThroughPFC: renderBadgeIPS(t.health_of_ips_modules_through_pfc),
                            availabilityOfStandbyPowerSupply: renderBadgeIPS(t.availability_of_stand_by_power_supply),
                            timeStamp: moment(t.created_at).format('DD MMM YYYY h:mm a'),
                        }));
                        setIPSData(ipsDataArray);
                        setIPSGraph(response.ips);
                    }

                    if (response.hassdac && Object.keys(response.hassdac).length > 0) {
                        const hassdacDataArray = response.hassdac.tableData.map((t) => ({
                            id: t._id,

                            hassdac: t.hassdac,
                            inputVoltage: renderStatus(t.severity_status[0].inputVoltage, t.input_voltage),
                            vitalrelayVoltage: renderStatus(
                                t.severity_status[0].vitalrelayVoltage,
                                t.vital_relay_voltage
                            ),
                            inputCurrent: renderStatus(t.severity_status[0].inputCurrent, t.input_current),
                            vitalrelayCurrent: renderStatus(
                                t.severity_status[0].vitalrelayCurrent,
                                t.vital_relay_current
                            ),
                            resetVoltage: renderStatus(t.severity_status[0].resetVoltage, t.reset_voltage),
                            timeStamp: moment(t.created_at).format('DD MMM YYYY h:mm a'),
                        }));
                        setHasscadData(hassdacDataArray);
                        setHasscadGraph(response.hassdac);
                    }
                }
            } else {
                toast.error('Please select all fields', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error fetching report:', error);
            toast.error('Failed to fetch report', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            // End loading indicator
            Loading();
        }
    };

    const inputRef = useRef(null);
    const printDocument = async () => {
        Loading();

        const options = {
            backgroundColor: '#f1f3fa',
            allowTaint: true,
            useCORS: true,
            logging: false,
        };

        try {
            const canvas = await html2canvas(inputRef.current, options);
            const imgData = canvas.toDataURL('image/png');

            const componentWidth = inputRef.current.offsetWidth;
            const componentHeight = inputRef.current.offsetHeight;

            const orientation = componentWidth >= componentHeight ? 'l' : 'p';

            const pdf = new jsPDF({
                orientation,
                unit: 'px',
                format: [componentWidth, componentHeight],
                compress: true,
            });

            pdf.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight);
            pdf.save(`RDPMS Update Report - ${moment().format('DD-MMM-YYYY')}.pdf`);
        } catch (error) {
            console.error('Error generating PDF:', error);
        }

        Loading();
    };

    return (
        <>
            <ToastContainer />
            <Row>
                <Col>
                    <div className="page-title-box">
                        <div className="page-title-right">
                            <form className="d-flex">
                                <div className="input-group">
                                    {/* <HyperDatepicker
                                        value={selectedDate}
                                        inputClass="form-control-light"
                                        onChange={(date) => {
                                            // onDateChange(date);
                                        }}
                                    /> */}
                                </div>

                                <div className="col-12 col-md-auto ms-md-auto">
                                    <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2 mb-3">
                                        {/* Export Button */}
                                        <button
                                            className="export d-flex align-items-center justify-content-center flex-grow-1"
                                            type="button"
                                            onClick={() => {
                                                printDocument();
                                            }}>
                                            Export <i className="fas fa-file-export ms-1"></i>
                                        </button>

                                        {/* Update Button */}
                                        <button
                                            className="update d-flex align-items-center justify-content-center flex-grow-1"
                                            id="update">
                                            Update <i className="fas fa-sync-alt ms-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <h4 className="page-title">{t('Reports Alert Graph')}</h4>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card.Body>
                        <Row>
                            <Col lg={4}>
                                <div className="mb-3">
                                    <label>{t('Station')}</label> <br />
                                    <FormInput
                                        name="select"
                                        type="select"
                                        className="form-select"
                                        key="select"
                                        onChange={(e) => setSelectedStation(e.target.value)}>
                                        <option value="">{t('Select station')}</option>
                                        {station &&
                                            station.map((item, index) => {
                                                return (
                                                    <option key={index} value={item._id}>
                                                        {item.name}
                                                    </option>
                                                );
                                            })}
                                    </FormInput>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="mb-3">
                                    <label>{t('Category')}</label> <br />
                                    <FormInput
                                        name="select"
                                        type="select"
                                        className="form-select"
                                        key="select"
                                        onChange={(e) => {
                                            setSelectedDevice();
                                            setDeviceData([]);
                                            handleDevice(e);
                                        }}>
                                        <option value="">{t('Select Category')}</option>
                                        <option value="dcCircuit">{t('DC CIRCUIT')}</option>
                                        <option value="pointMachine">{t('POINT MACHINE')}</option>
                                        <option value="signals">{t('SIGNALS')}</option>
                                        <option value="batteries">{t('BATTERIES')}</option>
                                        <option value="ips">{t('IPS')}</option>
                                        <option value="hassdac">{t('HASSDAC')}</option>

                                        {/* <option value="axialCounters">{t('AXIAL COUNTERS')}</option>
                                            <option value="dataLogger">{t('DATA LOGGER')}</option>
                                            <option value="electronicsInterlocking">
                                                {t('ELECTRONIC INTERLOCKING')}
                                            </option> */}
                                    </FormInput>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="mb-3">
                                    <label>{t('Device')}</label> <br />
                                    <FormInput
                                        name="select"
                                        type="select"
                                        className="form-select"
                                        key="select"
                                        onChange={(e) => setSelectedDevice(e.target.value)}>
                                        <option value="">{t('Select Device')}</option>
                                        {selectedCategory === 'dcCircuit'
                                            ? deviceData &&
                                              deviceData.map((item, index) => (
                                                  <option key={index} value={item._id}>
                                                      {item.track_number}
                                                  </option>
                                              ))
                                            : selectedCategory === 'pointMachine'
                                            ? deviceData &&
                                              deviceData.map((item, index) => (
                                                  <option key={index} value={item._id}>
                                                      {item.point_machine}
                                                  </option>
                                              ))
                                            : selectedCategory === 'signals'
                                            ? deviceData &&
                                              deviceData.map((item, index) => (
                                                  <option key={index} value={item._id}>
                                                      {item.signal_number}
                                                  </option>
                                              ))
                                            : selectedCategory === 'batteries'
                                            ? deviceData &&
                                              deviceData.map((item, index) => (
                                                  <option key={index} value={item._id}>
                                                      {item.battery_charger}
                                                  </option>
                                              ))
                                            : selectedCategory === 'ips'
                                            ? deviceData &&
                                              deviceData.map((item, index) => (
                                                  <option key={index} value={item._id}>
                                                      {item.ips}
                                                  </option>
                                              ))
                                            : selectedCategory === 'hassdac'
                                            ? deviceData &&
                                              deviceData.map((item, index) => (
                                                  <option key={index} value={item._id}>
                                                      {item.hassdac}
                                                  </option>
                                              ))
                                            : ''}
                                    </FormInput>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="mb-3">
                                    <label>{t('Start Date')}</label> <br />
                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                    {selectedStartDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedStartDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="mb-3">
                                    <label>{t('End Date')}</label> <br />
                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedEndDate(date)}
                                        />
                                    </div>
                                    {selectedEndDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedEndDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Button variant="primary" onClick={handleGetReport}>
                            {t('Submit')}
                        </Button>
                    </Card.Body>
                </Col>
            </Row>

            <div ref={inputRef}>
                {dcCircuitData.length > 0 ? (
                    <Row>
                        <Col>
                            <Card>
                                <Card.Header as="h4">
                                    DC Circuit
                                    <Row>
                                        <Col
                                            style={{
                                                fontSize: '16px',
                                                marginTop: '15px',
                                            }}>
                                            {' ' +
                                                'Start Date : ' +
                                                moment(selectedStartDate).format('Do MMM YYYY') +
                                                ' To End Date : ' +
                                                moment(selectedEndDate).format('Do MMM YYYY')}
                                        </Col>
                                        <Col>
                                            <div className="text-sm-end">
                                                <img
                                                    src={reportImg}
                                                    alt="hamingbird"
                                                    style={{
                                                        width: '25%',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Table
                                        columns={dcCircuitColumns(t)}
                                        data={dcCircuitData}
                                        isSortable={true}
                                        isSearchable={true}
                                    />
                                </Card.Body>
                                <Card.Footer>
                                    Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    ''
                )}
                {Object.keys(dcCircuitGraph).length > 0 ? (
                    <div>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Current')}</Card.Header>
                                    <Card.Body>
                                        <CurrentLineChart
                                            feedEndCurrent={dcCircuitGraph && dcCircuitGraph.feedEndCurrent}
                                            relayEndCurrent={dcCircuitGraph && dcCircuitGraph.relayEndCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Voltage')}</Card.Header>
                                    <Card.Body>
                                        <VoltageLineChart
                                            feedEndVoltage={dcCircuitGraph && dcCircuitGraph.feedEndVoltage}
                                            relayEndVoltage={dcCircuitGraph && dcCircuitGraph.relayEndVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Charger Current')}</Card.Header>
                                    <Card.Body>
                                        <ChargerCurrentLineChart
                                            color={'#00A300'}
                                            data={dcCircuitGraph && dcCircuitGraph.chargerCurrent}
                                        />
                                        <Card.Footer>
                                            Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                        </Card.Footer>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('TPR STATUS')}</Card.Header>
                                    <Card.Body>
                                        <TPRStatusStepLineChart
                                            color={'#979797'}
                                            data={dcCircuitGraph && dcCircuitGraph.tpr}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Charger Potential Free Contact')}</Card.Header>
                                    <Card.Body>
                                        <ChargerPotentialFreeContactStepLineChart
                                            color={'#979797'}
                                            data={dcCircuitGraph && dcCircuitGraph.chargerPotentialFreeContact}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    ''
                )}

                {pointMachineData.length > 0 ? (
                    <Row>
                        <Col>
                            <Card className="mt-3">
                                <Card.Header as="h4">
                                    Point Machine
                                    <Row>
                                        <Col
                                            style={{
                                                fontSize: '16px',
                                                marginTop: '15px',
                                            }}>
                                            {' ' +
                                                'Start Date : ' +
                                                moment(selectedStartDate).format('Do MMM YYYY') +
                                                ' To End Date : ' +
                                                moment(selectedEndDate).format('Do MMM YYYY')}
                                        </Col>
                                        <Col>
                                            <div className="text-sm-end">
                                                <img
                                                    src={reportImg}
                                                    alt="hamingbird"
                                                    style={{
                                                        width: '25%',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Table
                                        columns={pointMachineColumns(t)}
                                        data={pointMachineData}
                                        isSortable={true}
                                        isSearchable={true}
                                    />
                                </Card.Body>
                                <Card.Footer>
                                    Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    ''
                )}

                {Object.keys(pointMachineGraph).length > 0 ? (
                    <div>
                        <Row>
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Normal Operating Current')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <OperatingCurrentLineChart
                                            data={pointMachineGraph && pointMachineGraph.forwardOperatingCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Reverse Operating Current')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <OperatingCurrentLineChart
                                            data={pointMachineGraph && pointMachineGraph.reverseOperatingCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Normal Operating Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <OperatingVoltageLineChart
                                            data={pointMachineGraph && pointMachineGraph.forwardOperatingVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Reverse Operating Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <OperatingVoltageLineChart
                                            data={pointMachineGraph && pointMachineGraph.reverseOperatingVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>

                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Point Position Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <PointPositionStepLineChart
                                            data={pointMachineGraph && pointMachineGraph.pointPositionVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>

                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Point Position Relay')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <RelayStepLineChart
                                            data={pointMachineGraph && pointMachineGraph.pointPositionRelay}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    ''
                )}

                {signalData.length > 0 ? (
                    <Row>
                        <Col>
                            <Card className="mt-3">
                                <Card.Header as="h4">
                                    Signal
                                    <Row>
                                        <Col
                                            style={{
                                                fontSize: '16px',
                                                marginTop: '15px',
                                            }}>
                                            {' ' +
                                                'Start Date : ' +
                                                moment(selectedStartDate).format('Do MMM YYYY') +
                                                ' To End Date : ' +
                                                moment(selectedEndDate).format('Do MMM YYYY')}
                                        </Col>
                                        <Col>
                                            <div className="text-sm-end">
                                                <img
                                                    src={reportImg}
                                                    alt="hamingbird"
                                                    style={{
                                                        width: '25%',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Table
                                        columns={SignalColumns(t)}
                                        data={signalData}
                                        isSortable={true}
                                        isSearchable={true}
                                    />
                                </Card.Body>
                                <Card.Footer>
                                    Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    ''
                )}

                {Object.keys(signalGraph).length > 0 ? (
                    <div>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">
                                            {t('AC Current ')}
                                            {t('Signal')}
                                        </h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <ACCurrentLineChart
                                            redAcCurrent={signalGraph && signalGraph.redAcCurrent}
                                            greenAcCurrent={signalGraph && signalGraph.greenAcCurrent}
                                            yellowAcCurrent={signalGraph && signalGraph.yellowAcCurrent}
                                            otherAcCurrent={signalGraph && signalGraph.otherAcCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">
                                            {t('AC Voltage ')} {t('Signal')}
                                        </h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <ACVoltageLineChart
                                            redAcVoltage={signalGraph && signalGraph.redAcVoltage}
                                            greenAcVoltage={signalGraph && signalGraph.greenAcVoltage}
                                            yellowAcVoltage={signalGraph && signalGraph.yellowAcVoltage}
                                            otherAcVoltage={signalGraph && signalGraph.otherAcVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    ''
                )}

                {batteriesData.length > 0 ? (
                    <Row>
                        <Col>
                            <Card className="mt-3">
                                <Card.Header as="h4">
                                    Batteries
                                    <Row>
                                        <Col
                                            style={{
                                                fontSize: '16px',
                                                marginTop: '15px',
                                            }}>
                                            {' ' +
                                                'Start Date : ' +
                                                moment(selectedStartDate).format('Do MMM YYYY') +
                                                ' To End Date : ' +
                                                moment(selectedEndDate).format('Do MMM YYYY')}
                                        </Col>
                                        <Col>
                                            <div className="text-sm-end">
                                                <img
                                                    src={reportImg}
                                                    alt="hamingbird"
                                                    style={{
                                                        width: '25%',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Table
                                        columns={batteriesColumns(t)}
                                        data={batteriesData}
                                        isSortable={true}
                                        isSearchable={true}
                                    />
                                </Card.Body>
                                <Card.Footer>
                                    Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    ''
                )}

                {Object.keys(batteriesGraph).length > 0 ? (
                    <div>
                        <Row>
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Charger input Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <ChargerInputVoltagetLineChart
                                            data={batteriesGraph && batteriesGraph.chargerInputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Charger input Current')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <ChargerInputCurrenttLineChart
                                            data={batteriesGraph && batteriesGraph.chargerInputCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Charger Output Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <ChargerOutputVoltagetLineChart
                                            data={batteriesGraph && batteriesGraph.chargerOutputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Charger output Current')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <ChargerOutputCurrentLineChart
                                            data={batteriesGraph && batteriesGraph.chargerOutputCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Combined Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <BatteryOutputVoltageLineChart
                                            data={batteriesGraph && batteriesGraph.batteryOutputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={12} md={12}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Combined Current')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <BatteryOutputCurrentLineChart
                                            data={batteriesGraph && batteriesGraph.batteryOutputCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                        </Row>
                    </div>
                ) : (
                    ''
                )}

                {ipsData.length > 0 ? (
                    <Row>
                        <Col>
                            <Card className="mt-3">
                                <Card.Header as="h4">
                                    IPS
                                    <Row>
                                        <Col
                                            style={{
                                                fontSize: '16px',
                                                marginTop: '15px',
                                            }}>
                                            {' ' +
                                                'Start Date : ' +
                                                moment(selectedStartDate).format('Do MMM YYYY') +
                                                ' To End Date : ' +
                                                moment(selectedEndDate).format('Do MMM YYYY')}
                                        </Col>
                                        <Col>
                                            <div className="text-sm-end">
                                                <img
                                                    src={reportImg}
                                                    alt="hamingbird"
                                                    style={{
                                                        width: '25%',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Table
                                        columns={IPSColumns(t)}
                                        data={ipsData}
                                        isSortable={true}
                                        isSearchable={true}
                                    />
                                </Card.Body>
                                <Card.Footer>
                                    Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    ''
                )}

                {Object.keys(ipsGraph).length > 0 ? (
                    <div>
                        <Row>
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Input Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <InputVoltageLineChart data={ipsGraph && ipsGraph.inputVoltage} />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Input Current')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <InputCurrentLineChart data={ipsGraph && ipsGraph.inputCurrent} />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('DC 24 Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <BatteryOutputVoltageLineChart
                                            data={ipsGraph && ipsGraph.batteryOutputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('DC Current (24V Channel)')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <BatteryChargingCurrentLineChart
                                            data={ipsGraph && ipsGraph.batteryChargingCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('DC 110V (Battery Voltage)')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <DCConverterOutputVoltageLineChart
                                            data={ipsGraph && ipsGraph.dcConverterOutputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('DC Current (110V)')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <DCConverterOutputCurrentLineChart
                                            data={ipsGraph && ipsGraph.dcConverterOutputCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Inverter Input Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <InverterInputVoltageLineChart
                                            data={ipsGraph && ipsGraph.inverterInputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('AC Current 110v')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <InverterOutputCurrentLineChart
                                            data={ipsGraph && ipsGraph.inverterOutputCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('AC 110 Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <InverterOutputVoltageLineChart
                                            data={ipsGraph && ipsGraph.inverterOutputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('FRBC Output Voltage')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <FRBCOutputVoltageLineChart data={ipsGraph && ipsGraph.frbcOutputVoltage} />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">{t('Health of IPS models through PFC')}</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <HealthOfIPSModelsThroughPFCStepLineChart
                                            data={ipsGraph && ipsGraph.healthOfIPSModulesThroughPFC}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>{' '}
                            <Col xxl={6} md={6}>
                                <Card className="mt-3">
                                    <Card.Header>
                                        <h4 className="header-title mb-3">
                                            {t('Availability of Standby Power Supply')}
                                        </h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <AvailabilityOfStandbyPowerSupplyStepLineChart
                                            data={ipsGraph && ipsGraph.availabilityOfStandByPowerSupply}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    ''
                )}

                {hasscadData.length > 0 ? (
                    <Row>
                        <Col>
                            <Card className="mt-3">
                                <Card.Header as="h4">
                                    HASSCAD
                                    <Row>
                                        <Col
                                            style={{
                                                fontSize: '16px',
                                                marginTop: '15px',
                                            }}>
                                            {' ' +
                                                'Start Date : ' +
                                                moment(selectedStartDate).format('Do MMM YYYY') +
                                                ' To End Date : ' +
                                                moment(selectedEndDate).format('Do MMM YYYY')}
                                        </Col>
                                        <Col>
                                            <div className="text-sm-end">
                                                <img
                                                    src={reportImg}
                                                    alt="hamingbird"
                                                    style={{
                                                        width: '25%',
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Table
                                        columns={hassdacColumns(t)}
                                        data={hasscadData}
                                        isSortable={true}
                                        isSearchable={true}
                                    />
                                </Card.Body>
                                <Card.Footer>
                                    Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    ''
                )}
                {Object.keys(hasscadGraph).length > 0 ? (
                    <div>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Input Current')}</Card.Header>
                                    <Card.Body>
                                        <InputCurrentHASSDACLineChart
                                            inputCurrent={hasscadGraph && hasscadGraph.inputCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Input Voltage')}</Card.Header>
                                    <Card.Body>
                                        <InputVoltageHASSDACLineChart
                                            inputVoltage={hasscadGraph && hasscadGraph.inputVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Vital Relay Voltage')}</Card.Header>
                                    <Card.Body>
                                        <VitalRelayVoltageLineChart
                                            vitalrelayVoltage={hasscadGraph && hasscadGraph.vitalRelayVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Vital Relay Current')}</Card.Header>
                                    <Card.Body>
                                        <VitalRelayCurrentLineChart
                                            vitalrelayCurrent={hasscadGraph && hasscadGraph.vitalRelayCurrent}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card className="mt-3">
                                    <Card.Header as="h5">{t('Reset Voltage')}</Card.Header>
                                    <Card.Body>
                                        <ResetVoltageLineChart
                                            resetVoltage={hasscadGraph && hasscadGraph.resetVoltage}
                                        />
                                    </Card.Body>
                                    <Card.Footer>
                                        Copyright {currentYear} Hummingbird TekSystems, Inc.| CONFIDENTIAL
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </>
    );
};

export default ReportsAlertGraph;
